import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeFirebase } from './services/FirebaseService';

// Import CSS files
import './assets/css/global-overflow.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/dark.css';
import './assets/css/animate.min.css';
import './assets/css/aos.css';
import './assets/css/flaticon.css';
import './assets/css/font-awesome-all.css';
import './assets/css/jarallax.css';
import './assets/css/jquery-ui.css';
import './assets/css/jquery.magnific-popup.css';
import './assets/css/nice-select.css';
import './assets/css/odometer.min.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/owl.theme.default.min.css';
import './assets/css/swiper.min.css';
import './assets/css/twentytwenty.css';
import './assets/css/custom-animate.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

// 🛡️ CRITICAL: Ensure page is NEVER locked on initial load (mobile fix)
// Remove any blocking styles immediately on page load
const ensurePageUnlocked = () => {
    // Remove page-loading class if it exists
    document.body.classList.remove('page-loading');
    
    // Ensure body is never locked
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.body.style.top = '';
    
    // Ensure html is never locked
    document.documentElement.style.overflow = '';
    document.documentElement.style.position = '';
    
    // Ensure home page content is visible
    const homePage = document.querySelector('.home-page');
    if (homePage) {
        homePage.classList.remove('home-page--loading');
    }
};

// Run immediately on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensurePageUnlocked);
} else {
    ensurePageUnlocked();
}

// Run a small, finite sequence only (avoids constant work on scroll/animations)
setTimeout(ensurePageUnlocked, 120);
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        ensurePageUnlocked();
    });
});

// ⚡ CRITICAL: Initialize Firebase BEFORE rendering React
// This ensures Firebase is ready when components try to use it
try {
    console.log('🔥 Initializing Firebase before React render...');
    initializeFirebase();
    console.log('✅ Firebase ready, rendering React app...');
} catch (error) {
    console.error('❌ Fatal: Failed to initialize Firebase:', error);
    // Show error to user instead of blank screen
    rootElement.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: Arial, sans-serif; background: #f5f5f5;">
            <div style="text-align: center; padding: 20px; background: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                <h1 style="color: #e74c3c; margin-bottom: 10px;">⚠️ Connection Error</h1>
                <p style="color: #666; margin-bottom: 20px;">Unable to connect to Firebase. Please check your internet connection and try again.</p>
                <button onclick="window.location.reload()" style="background: #3498db; color: white; border: none; padding: 10px 20px; border-radius: 4px; cursor: pointer; font-size: 16px;">
                    Retry
                </button>
            </div>
        </div>
    `;
    throw error;
}

root.render(
    <React.StrictMode>
                    <App/>
    </React.StrictMode>
);
